import * as sanitize from '@/shared/util/sanitize-html/types';

export const SANITIZE_OPTIONS: sanitize.IOptions = {
  allowedTags: [
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'b',
    'bdi',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dir',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'select',
    'small',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'tt',
    'u',
    'ul',
    'var',
    'wbr',
  ],
  allowedAttributes: {
    '*': [
      'abbr',
      'accept',
      'accept-charset',
      'accesskey',
      'action',
      'align',
      'alt',
      'aria-*',
      'autocomplete',
      'autosave',
      'axis',
      'bgcolor',
      'border',
      'cellpadding',
      'cellspacing',
      'challenge',
      'char',
      'charoff',
      'charset',
      'checked',
      'cite',
      'class',
      'clear',
      'color',
      'cols',
      'colspan',
      'compact',
      'contenteditable',
      'coords',
      'data-*',
      'datetime',
      'dir',
      'disabled',
      'draggable',
      'dropzone',
      'enctype',
      'for',
      'frame',
      'headers',
      'height',
      'high',
      'href',
      'hreflang',
      'hspace',
      'ismap',
      'keytype',
      'label',
      'lang',
      'list',
      'longdesc',
      'low',
      'max',
      'maxlength',
      'media',
      'method',
      'min',
      'multiple',
      'name',
      'nohref',
      'noshade',
      'novalidate',
      'nowrap',
      'open',
      'optimum',
      'pattern',
      'placeholder',
      'prompt',
      'pubdate',
      'radiogroup',
      'readonly',
      'rel',
      'required',
      'rev',
      'reversed',
      'role',
      'rows',
      'rowspan',
      'rules',
      'scope',
      'selected',
      'shape',
      'size',
      'span',
      'spellcheck',
      'src',
      'start',
      'step',
      'style',
      'summary',
      'tabindex',
      'target',
      'title',
      'type',
      'usemap',
      'valign',
      'value',
      'vspace',
      'width',
      'wrap',
    ],
    a: ['href', 'name', 'target'],
    html: ['xmlns'],
    img: ['src', 'alt', 'title', 'width', 'height'],
    meta: ['content', 'http-equiv'],
  },
  allowedSchemes: ['mailto', 'http', 'https', '{{'],
};
